import BaseService from '../base.service';

export class LotteryService {
  // 查询彩票列表
  static async lotteryListApi() {
    return BaseService.get('/web/lottery');
  }

  // 根据彩票id去查询限额
  static async LotteryRestrictedByLotteryApi(lotteryId) {
    return BaseService.get(`/web/lottery/lottery/${lotteryId}`);
  }
  // 查询中奖号码
  static async getLotteryDrawApi(queryOptions) {
    return BaseService.get('/web/lottery/queryLottery', queryOptions);
  }
}
